import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MortgageDashboardHandover } from '../../../models/mortgage-dashboard';

export const fixHandoverId = (formValue: any): any => {
  const value = { ...formValue };

  if (value.handoverId) {
    value.handoverId = value.handoverId.id;
  }

  return value;
};

@Injectable({ providedIn: 'root' })
export class SelectApplicationLenderService {
  public application$ = new Subject<MortgageDashboardHandover>();

  public handovers: MortgageDashboardHandover[];

  public selectedHandover: MortgageDashboardHandover;
}
